import { render, staticRenderFns } from "./bankPay.vue?vue&type=template&id=5869bc45&scoped=true"
import script from "./bankPay.vue?vue&type=script&lang=js"
export * from "./bankPay.vue?vue&type=script&lang=js"
import style0 from "./bankPay.vue?vue&type=style&index=0&id=5869bc45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869bc45",
  null
  
)

export default component.exports